import { monthNoToMonthStr } from "../utils/TicketBooking";

const date = new Date();
export const getCurrentDate = () => {
  return `${date.getFullYear()}-${
    date.getMonth() + 1 < 10 ? "0" : ""
  }${date.getMonth() + 1}-${date.getDate() < 10 ? "0" : ""}${date.getDate()}`;
};

export const getCurrentTime = () => {
  return `${date.getHours() < 10 ? "0" : ""}${date.getHours()}:${
    date.getMinutes() < 10 ? "0" : ""
  }${date.getMinutes()}`;
};

export const formatDate = (dateStr) => {
  const [year, month, date] = dateStr.split("-");
  return `${date} ${monthNoToMonthStr(month)} ${year}`
};
